var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"interactives-list-item"},[_c('span',{staticClass:"item-content"},[_vm._v(_vm._s(_vm.itemContent))]),_vm._v(" "),_c('button',{staticClass:"item-close",on:{"click":function($event){_vm.$emit('remove')}}},[_vm._v("(Remove)")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-14271851","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!../interactives-input/src/components/ListItem.vue
// module id = G9ae
// module chunks = 1